import { Box, useTheme } from "@mui/material";

export const DragModeSnackbar = ({ visible }: { visible: boolean }) => {
	const theme = useTheme();

	if (!visible) return null;

	return (
		<Box
			sx={{
				position: "fixed",
				bottom: 24,
				left: "50%",
				transform: "translateX(-50%)",
				backgroundColor: theme.palette.grey[800],
				color: theme.palette.common.white,
				padding: "10px 20px",
				borderRadius: "8px",
				fontSize: "0.875rem",
				boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
				zIndex: 10000,
				pointerEvents: "none",
			}}
		>
			Drag and Drop - Press <strong>'ESC'</strong> to cancel
		</Box>
	);
};
